import { render, staticRenderFns } from "./Bordero.vue?vue&type=template&id=25fc59f5&scoped=true&"
import script from "./Bordero.vue?vue&type=script&lang=js&"
export * from "./Bordero.vue?vue&type=script&lang=js&"
import style0 from "./Bordero.vue?vue&type=style&index=0&id=25fc59f5&prod&lang=scss&scoped=true&"
import style1 from "./Bordero.vue?vue&type=style&index=1&id=25fc59f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc59f5",
  null
  
)

export default component.exports